import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import ModelDetail from "@/pages/ModelDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function ScrollToTopOnRoute() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  });
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-slate-50 text-slate-950 font-body">
      <BrowserRouter>
        <ScrollToTopOnRoute />
        <Navbar />
        <main data-testid="site-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/models" element={<Models />} />
            <Route path="/models/:slug" element={<ModelDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
